import React from 'react';

import { ArrowButtonPop } from '../ArrowButton/ArrowButtonPop';
import { useArrowButton } from '../ArrowButton/useArrowButton';
import { CardScroller } from '../CardScroller/CardScroller';

export function BanksMortgageOffersScroller({
    children,
    isControls
}: {
    isControls?: boolean;
    children: React.ReactNode;
}) {
    const {
        onArrowClick,
        onContainerScroll,
        isLeftEdge,
        isRightEdge,
        containerRef
    } = useArrowButton();

    return (
        <CardScroller
            children={children}
            onContainerScroll={onContainerScroll}
            isLeftMask={! isLeftEdge}
            isRightMask={! isRightEdge}
            containerRef={containerRef}
            controls={
                isControls && (<ArrowButtonPop
                    isDisabledToHide
                    onArrowClick={onArrowClick}
                    isLeftEdge={isLeftEdge}
                    isRightEdge={isRightEdge}
                />)
            }
        />
    );
}
